export const GRIMOIRE_PAGES = [
  {
    id: 1,
    title: "L'apprentie Horlogère",
    art_bg: "from-amber-900/40 to-stone-950",
    panels: [
      "Il était une fois, aux confins du temps, une jeune fille nommée Luna...",
      "Élevée par les Horlogers du Temps, elle apprit très jeune que le monde n'était pas linéaire.",
      "« Chaque instant, murmura son maître, est une porte. À toi de trouver la clef. »",
    ],
  },
  {
    id: 2,
    title: "La Fissure Découverte",
    art_bg: "from-emerald-900/40 to-stone-950",
    panels: [
      "Un jour, une lueur étrange déchira le ciel de son atelier...",
      "Trois époques s'entrechoquaient : le Nil, un beffroi et une cité de néon.",
      "Luna comprit : les fils du temps s'effilochaient, et personne d'autre ne pouvait les recoudre.",
    ],
  },
  {
    id: 3,
    title: "Les Lois de la Causalité",
    art_bg: "from-teal-900/40 to-stone-950",
    panels: [
      "Chaque geste dans une époque résonnait dans les autres — comme des vagues.",
      "Une braise médiévale allumait un moteur cybernétique. Un cristal du désert éclairait le futur.",
      "Luna apprit à penser en spirales, non plus en lignes droites.",
    ],
  },
  {
    id: 4,
    title: "La Fissure Finale",
    art_bg: "from-fuchsia-900/30 to-stone-950",
    panels: [
      "Au cœur du futur, la fissure ultime attendait.",
      "Trois époques, trois artefacts, un seul instant à saisir.",
      "« Ce n'est pas la vitesse qui compte, dit Luna, mais la précision du geste. »",
      "Et le temps, enfin, retrouva son chant.",
    ],
  },
  {
    id: 5,
    title: "L'Éclipse du Théâtre",
    art_bg: "from-rose-900/40 to-stone-950",
    panels: [
      "Sur les planches d'une scène Renaissance, une comédie se joue à voix basse...",
      "Un dramaturge écrit sans jamais lever la plume, hanté par une ombre solaire.",
      "Luna comprit que le théâtre était une machine à comprendre le temps.",
      "Le rideau se leva sur une éclipse ; le silence, enfin, avait sa réplique.",
    ],
  },
];
